// Stub — removed per EduBridge migration §4.6. Renders nothing.
import React from 'react';
const CreditCostBadge = () => null;
export const CREDIT_FEATURES = new Proxy({}, { get: () => 0 });
export default CreditCostBadge;
